"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _styles = require("@material-ui/core/styles");

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _constants = require("../../utils/constants");

var _SearchBadge = require("./SearchBadge");

require("./index.css");

var MIN_INPUT_WIDTH = 300;

var Search = function Search(_ref, ref) {
  var query = _ref.query,
      placeholder = _ref.placeholder,
      count = _ref.count,
      isLoading = _ref.isLoading,
      _onChange = _ref.onChange,
      onHandleEnter = _ref.onHandleEnter,
      onCancel = _ref.onCancel,
      onBlur = _ref.onBlur,
      tips = _ref.tips,
      tokens = _ref.tokens,
      children = _ref.children,
      prefix = _ref.prefix,
      searchContactBadge = _ref.searchContactBadge,
      onFocus = _ref.onFocus,
      onHandleBackspace = _ref.onHandleBackspace,
      options = _ref.options,
      onClose = _ref.onClose,
      pill = _ref.pill;

  var _useTheme = (0, _styles.useTheme)(),
      palette = _useTheme.palette; // Create a ref and handle esc keys


  var textAreaRef = (0, _react.useRef)(null);

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      onBlur: function onBlur() {
        if (textAreaRef.current) {
          textAreaRef.current.blur();
        }
      },
      onFocus: function onFocus() {
        if (textAreaRef.current) {
          textAreaRef.current.focus();
        }
      }
    };
  });

  var blur = function blur() {
    if ((0, _isNil["default"])(textAreaRef)) {
      return;
    }

    if (!(0, _isNil["default"])(textAreaRef.current)) {
      textAreaRef.current.blur();
    }
  }; // Capture enter key here


  (0, _react.useEffect)(function () {
    var preventEnterKey = function preventEnterKey(e) {
      if (e.keyCode === 13) {
        e.preventDefault();

        if (textAreaRef.current) {
          textAreaRef.current.blur();
        }
      }
    };

    textAreaRef.current.addEventListener('keydown', preventEnterKey, false);
    return function () {
      textAreaRef.current.removeEventListener('keydown', preventEnterKey, false);
    };
  }, []);
  var autoSizeCallback = (0, _react.useCallback)(function () {
    if (textAreaRef.current && tokensRef.current) {
      textAreaRef.current.style.width = "".concat(MIN_INPUT_WIDTH, "px");

      if (textAreaRef.current.scrollWidth > textAreaRef.current.offsetWidth) {
        var maxWidth = tokensRef.current.offsetWidth - 8;
        var currWidth = textAreaRef.current.scrollWidth;
        textAreaRef.current.style.width = "".concat(Math.min(maxWidth, currWidth), "px");
      }
    }
  }, []);
  var resizeCallback = (0, _react.useCallback)(function () {
    if (textAreaRef.current) {
      textAreaRef.current.style.width = "".concat(MIN_INPUT_WIDTH, "px");
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (query.trim().length) {
      autoSizeCallback();
    } else {
      resizeCallback();
    }
  }, [query]);

  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === 27) {
      if (textAreaRef.current) {
        textAreaRef.current.blur();
      }
    } else if (e.key === 'Enter' && onHandleEnter) {
      onHandleEnter();
    } else if (e.key === 'Backspace') {
      onHandleBackspace();
    }
  };

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      scrollPosition = _useState2[0],
      setScrollPosition = _useState2[1];

  var tokensRef = (0, _react.useRef)(null);

  var synchronizeScroll = function synchronizeScroll(e) {
    if ((0, _isNil["default"])(tokensRef.current)) {
      return;
    }

    tokensRef.current.scrollLeft = e.target.scrollLeft;
    setScrollPosition(e.target.scrollLeft);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col h-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "z-10"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center border-b-1 rounded-none"
  }, /*#__PURE__*/_react["default"].createElement(_Search["default"], {
    style: {
      fontSize: '2.5rem'
    },
    className: "ml-12 pb-2"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 min-w-0 px-5 py-8"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative inline-flex flex-no-wrap w-full h-14 min-w-0 text-2xl"
  }, /*#__PURE__*/_react["default"].createElement(_SearchBadge.SearchRecommendBadge, {
    onClose: onClose,
    options: options
  }), /*#__PURE__*/_react["default"].createElement("textarea", {
    autoFocus: true,
    ref: textAreaRef,
    spellCheck: false,
    placeholder: placeholder,
    className: "z-10 flex-1 overflow-x-scroll h-12 overflow-y-hidden font-bold bg-transparent outline-none resize-none disable-scrollbars",
    rows: "1",
    style: {
      caretColor: 'var(--color-primary)',
      fontSize: '1.75rem',
      paddingTop: '2px'
    },
    value: query,
    onChange: function onChange(e) {
      _onChange(e.target.value.replace(/(\r\n|\n|\r)/gm, ''));
    },
    onKeyDown: handleKeyDown,
    onScroll: synchronizeScroll,
    onBlur: onBlur,
    onFocus: onFocus,
    wrap: "off",
    autoComplete: "off"
  }), typeof tokens === 'function' ? tokens({
    scrollPosition: scrollPosition,
    blur: blur
  }) : tokens)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('mr-3 flex-shrink-0', {
      invisible: count === 0
    })
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold text-light text-xs"
  }, t('search.results', {
    count: count
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mr-5 cursor-pointer text-light",
    onClick: onCancel
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    style: {
      fontSize: '2rem'
    }
  })))), /*#__PURE__*/_react["default"].createElement("div", null, tips)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-5"
  }, pill), children);
};

var _default = /*#__PURE__*/(0, _react.forwardRef)(Search);

exports["default"] = _default;
//# sourceMappingURL=index.js.map